module.exports = __webpack_public_path__ + "img/1307.6028f2cd.gif";